export var selectOngoingPurchaseInfo = function (state) { return state.ongoingPurchase; };
export var selectOngoingPurchaseInfoStandard = function (state) { return state.ongoingPurchase.standard; };
export var selectOngoingPurchaseInfoPremium = function (state) { return state.ongoingPurchase.premium; };
export var selectOngoingPurchaseProcessToSkip = function (state) {
    return state.ongoingPurchase.quickSkipProcessId;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectOngoingPurchaseInfo.ts
// module id = 343
// module chunks = 3